<div class="hero">
  <div class="hero-overlay">
  </div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          Our Year In Review
        </h1>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <div class="top-first-section">
    <div class="text-center mt-3">
      <h2>
        <span class="fw-bold">identi is the home to over  </span>
      </h2>
    </div>
    <div>
      <img src="/assets/images/identibase-review/7million-pets.svg" class="top-first-section-image" alt="pets-registered"/>
    </div>
    <div class="text-center mt-3">
      <h2 class="fw-bold">That’s more than the entire population of Yorkshire.</h2>
      <h2 class="fw-bold mt-4">We Couldn’t Have Done It Without You</h2>
    </div>
  </div>

  <div class="top-second-section">
    <div class="top-second-section-title">

    </div>
    <div class="top-second-section-container">
      <img src="/assets/images/identibase-review/review-1.svg" class="top-second-section-container-image" alt="review-one"/>
    </div>
    <div class="top-second-section-container">
      <img src="/assets/images/identibase-review/review-2.svg" class="top-second-section-container-image" alt="review-two"/>
    </div>
    <div class="top-second-section-container">
      <img src="/assets/images/identibase-review/review-3.svg" class="top-second-section-container-image" alt="review-three"/>
    </div>
  </div>
  <div class="center-top-section">
    <div class="center-top-section-left">
      <div class="center-top-section-left-text">
        <h2 class="fw-bold">This year, over 2819 pets were reunited with their keepers!</h2>
      </div>
    </div>
    <div class="center-top-section-center">
      <img class="center-top-section-center-image" src="/assets/images/identibase-review/man-and-woman-walking.svg" alt="man-and-woman-walking"/>
    </div>
    <div class="center-top-section-right">
      <div class="center-top-section-right-text">
        <h4 class="fw-bold">More than 75% of those reunited subscribe to our missing pet protection</h4>
      </div>
    </div>
  </div>
  <div class="mt-5 top-second-section-title">
    <h2 class="fw-bold">That’s a year full of happy endings and even happier tail wags.</h2>
  </div>
  <div class="center-mid-section">
    <div class="center-mid-section-left">
      <div class="center-mid-section-left-title">
        <h1 class="fw-bold">Most popular pet registrations:</h1>
      </div>
      <div class="center-mid-section-left-list">
        <ol>
          <h2 class="fw-bold"><li>London</li></h2>
          <h2 class="fw-bold"><li>Birmingham</li></h2>
          <h2 class="fw-bold"><li>Manchester</li></h2>
          <h2 class="fw-bold"><li>Glasgow</li></h2>
          <h2 class="fw-bold"><li>Nottingham</li></h2>
        </ol>
      </div>
    </div>
    <div class="center-mid-section-right">
      <div class="center-mid-section-right-image">
        <img src="/assets/images/identibase-review/england-registration-map.png" class="center-mid-section-right-image-content" alt="england-registration-map"/>
      </div>
    </div>
  </div>
  <div class="center-bottom-section">
    <div class="center-bottom-section-title">
      <h1 class="fw-bold">Most Popular Pet Names:</h1>
    </div>
    <div class="center-bottom-section-content">
      <div class="center-bottom-section-content-image">
        <img src="/assets/images/identibase-review/most-popular-pet-names.png" class="center-bottom-section-content-image-content" alt="most-popular-pet-names"/>
      </div>
      <div class="center-bottom-section-content-list">
        <ol>
          <h2 class="fw-bold"><li>Luna</li></h2>
          <h2 class="fw-bold"><li>Milo</li></h2>
          <h2 class="fw-bold"><li>Bella</li></h2>
          <h2 class="fw-bold"><li>Coco</li></h2>
          <h2 class="fw-bold"><li>Willow</li></h2>
        </ol>
      </div>
    </div>
    <div class="mt-5 top-second-section-title"><h2 class="fw-bold">Somewhere, a dog named Steve feels slightly overlooked.</h2></div>
  </div>
  <div class="bottom-top-section">
   <div class="d-flex bottom-top-section">
  <div class="bottom-top-section-content">
    <div class="bottom-top-section-content-top">
      <h2 class="fw-bold">13% of Cats are indoor only!</h2>
    </div>
    <div class="bottom-top-section-content-bottom">
      <h2 class="fw-bold">And 100% of them still believe they could absolutely survive in the wild… if they wanted to.</h2>
    </div>
  </div>
  <div class="bottom-top-section-image">
    <img src="/assets/images/identibase-review/christmas-tree-cat.svg" class="bottom-top-section-image-content" alt="christmas-tree-cat"/>
  </div>
</div>
  </div>
  <div class="bottom-mid-section">
    <div class="bottom-mid-section-title">
      <h1 class="fw-bold">Longest Pet Name:</h1>
    </div>
    <div class="bottom-mid-section-content">
      <div class="bottom-mid-section-content-text">
        <h1 class="fw-bold">Princess MoaMoa, Bringer of Chaos and Destruction</h1>
      </div>
      <div class="bottom-mid-section-content-image">
        <img src="/assets/images/identibase-review/longest-pet-name.png" class="bottom-mid-section-content-image-content" alt="football-stadium"/>
      </div>
    </div>
  </div>
</div>
<div class="container">
  <p class="text-center"><b>Source:</b> identi database records (Jan 1-Nov 11, 2025)</p>
</div>
